module.exports = __webpack_public_path__ + "media/quarterfold.4584f3ee.mp4";